module.exports = __webpack_public_path__ + "img/icon-logs-light.138f6a6c.svg";